import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTitle } from '../../redux/title/action';
import {
  InfoHeaderStyledContainer,
  RegisterStyledContainer,
} from '../../components/container/styles';
import { TextSmall } from '../../components/text';
import { useGetClaimList } from './hooks/useGetClaimList';
import { RenderForm } from '../../components/forms';
import { CLAIM_FORM, FORM_ADDRESS, FORM_PIC, FORM_SHOW_IMAGE_CLAIM } from './form';
import { color } from '../../resources';
import { Checkbox, Row, Spin, Col } from 'antd';
import { ContainerButton } from '../../styles/global-style';
import { ButtonTheme } from '../../components/buttons';
import React from 'react';
import { breakdownSubQuery } from '../../services/react-query/optionMasterQuery';

export const ClaimScene = () => {
  const dispatch = useDispatch();
  const warrantyData = useSelector((state) => state.warrantyData.data);
  const storedWarrantyData = localStorage.getItem('warrantyData');
  const parsedData = JSON.parse(storedWarrantyData);
  const [addressOptions, setAddressOptions] = useState([]);
  const [breakdownOptions, setBreakdownOptions] = useState([]);
  const [productType, setProductType] = useState('');
  const [channelClaimOptions, setChannelClaimOptions] = useState([]);
  const [isAccepted, setIsAccepted] = useState(false);
  const showOldAddress = true;

  const {
    control,
    getValues,
    setValue,
    watch,
    onCallZipCode,
    provinceOptions,
    districtOptions,
    subDistrictOptions,
    addressFullOptions,
    onChangeAddress,
    isLoadingZipCode,
    handleSubmit,
    onSubmit,
    isLoadingToSave,
  } = useGetClaimList();

  const breakdownId = watch('breakdownId');

  useEffect(() => {
    if (breakdownId) {
      const selectedBreakdown = breakdownOptions.find((item) => item.value === breakdownId);
      console.log('selectedBreakdown : ', selectedBreakdown);
      setProductType(selectedBreakdown.productType);
    }
  }, [breakdownId]);
  const { data: breakdownSubOptions, isLoading: isLoadingBreakdownSub } =
    breakdownSubQuery(productType);

  useEffect(() => {
    if (parsedData) {
      setAddressOptions(
        parsedData?.addresses?.map((item) => ({
          label: item.addressFullText,
          value: item.customerAddressId,
        })) || [],
      );

      setBreakdownOptions(
        parsedData?.warranty?.breakdowns?.map((item) => ({
          label: item.breakdownNameTh,
          value: item.breakdownId,
          productType: item.productType,
        })) || [],
      );

      setChannelClaimOptions(
        parsedData?.warranty?.channelClaims?.map((item) => ({
          label: item.channelClaimNameLineOa,
          value: item.channelClaimId,
        })) || [],
      );
    }
  }, []);

  useEffect(() => {
    if (warrantyData) {
      localStorage.setItem('warrantyData', JSON.stringify(warrantyData));
    }
  }, [warrantyData]);

  useEffect(() => {
    dispatch(setTitle('แจ้งเคลมสินค้า'));
  }, [dispatch]);

  useEffect(() => {
    if (storedWarrantyData) {
      setValue('warrantyCode', parsedData?.warranty?.warrantyCode);
      setValue('warrantyId', parsedData?.warranty?.warrantyId);
      setValue('mobileBrandName', parsedData?.warranty?.mobileBrandName);
      setValue('mobileModelName', parsedData?.warranty?.mobileModelName);

      if (parsedData?.warranty?.channelClaims?.length > 0) {
        setValue('channelClaimId', parsedData.warranty.channelClaims[0].channelClaimId);
      }
    }
  }, [setValue]);

  const handleCheckboxChange = (e) => {
    setIsAccepted(e.target.checked);
  };

  const onChangeBreakdown = (value, item) => {
    switch (item.name) {
      case 'breakdownId':
        setValue('breakdownSubId', null);
        break;
      default:
        break;
    }
  };

  return (
    <RegisterStyledContainer>
      <Spin spinning={isLoadingZipCode || isLoadingToSave || isLoadingBreakdownSub}>
        <InfoHeaderStyledContainer>
          <TextSmall text="กรุณากรอกข้อมูลเพื่อเคลมสินค้า" style={{ color: '#8c6e19' }} bold />
        </InfoHeaderStyledContainer>
        <Row gutter={[0, 10]} justify="center" style={{ padding: 20, paddingBottom: 50 }}>
          <Col span={24}>
            <RenderForm
              control={control}
              setValue={setValue}
              getValues={getValues}
              onChange={onChangeBreakdown}
              forms={CLAIM_FORM({ breakdownOptions, breakdownSubOptions })}
            />
          </Col>
          <Col span={24}>
            <RenderForm
              control={control}
              setValue={setValue}
              getValues={getValues}
              forms={FORM_SHOW_IMAGE_CLAIM()}
            />
          </Col>

          <Col span={24}>
            <RenderForm
              control={control}
              setValue={setValue}
              getValues={getValues}
              onChange={onChangeAddress}
              forms={FORM_ADDRESS({
                showOldAddress,
                watch,
                channelClaimOptions,
                addressOptions,
                onCallZipCode,
                provinceOptions,
                districtOptions,
                subDistrictOptions,
                addressFullOptions,
              })}
            />
          </Col>
          <Col span={24}>
            <Row justify="center">
              <Checkbox checked={isAccepted} onChange={handleCheckboxChange}>
                <span style={{ color: color.redRizz }}>
                  ข้าพเจ้าขอรับรองว่าข้อมูลข้างต้นเป็นความจริงทุกประการ
                  และข้อมูลดังกล่าวมีผลทางกฎหมาย
                </span>
              </Checkbox>
            </Row>
          </Col>

          <Col span={24}>
            <Row justify="center">
              <ContainerButton center>
                <ButtonTheme
                  useFor="CLAIM"
                  style={{ width: '100%' }}
                  onClick={handleSubmit(onSubmit)}
                  disabled={!isAccepted}
                />
              </ContainerButton>
            </Row>
          </Col>
        </Row>
      </Spin>
    </RegisterStyledContainer>
  );
};
